import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useHoldingContext } from '../../Contexts/CurrentHolding'
import { useHealthContext } from '../../Contexts/Modules/HealthModule/HealthModule'
import { DataGridPro } from '@mui/x-data-grid-pro'
import PageSection from '../../Constants&Theme/PageSection'

function ScreenComplete() {
  const navigate = useNavigate()
  const { currentHolding } = useHoldingContext()
  const { screensQuery } = useHealthContext()
  return (
    <PageSection title={`Pending Requests for ${currentHolding.name}`}>
      <DataGridPro
        sx={{ width: 1, maxWidth: 'md' }}
        hideFooter
        autoHeight
        loading={screensQuery.isLoading}
        rows={screensQuery.data?.Screens ?? []}
        getRowId={(row) => row.ScreenID}
        rowSelectionModel={[currentHolding.value]}
        columns={[
          {
            field: 'ScreenID',
            headerName: 'Screen ID',
            flex: 1,
          },
          {
            field: 'Name',
            headerName: 'Name',
            flex: 4,
          },
          {
            field: 'ScreenHoldingID',
            headerName: 'ScreenHoldingID',
          },
        ]}
        initialState={{
          columns: {
            columnVisibilityModel: {
              ScreenHoldingID: false,
            },
          },
        }}
        onRowClick={({ row }) =>
          navigate('/stuart/health/holding/' + row.ScreenHoldingID)
        }
      />
    </PageSection>
  )
}

export default ScreenComplete
